<template>
  <div id="app">
    <Navbar :companyName="companyName" />
    <router-view />
    <Footer :companyName="companyName" :contact="contact" />
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue';
import Footer from './components/Footer.vue';

export default {
  name: 'App',
  components: { Navbar, Footer },
  data() {
    return {
      companyName: 'SIWEECI Health Technology (Shanghai) Co., Ltd.',
      contact: {
        phone: '+86 150 5042 2744',
        email: 'Shirley-dodds@siweeci.com',
        address: 'Building No.30, Shuangyin Guoji, Guoxiang Street, Wuzhong District, Suzhou, Jiangsu, China'
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #ffffff;
  overflow-x: hidden;
}

html {
  scroll-behavior: smooth;
}

/* Scrollbar styles */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #2c5aa0;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #1e3a5f;
}

/* Animation effects */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.animate-on-scroll {
  animation: fadeInUp 0.8s ease-out;
}

.animate-slide-left {
  animation: slideInLeft 0.8s ease-out;
}

.animate-slide-right {
  animation: slideInRight 0.8s ease-out;
}

/* Responsive design */
@media (max-width: 768px) {
  .main-content {
    margin-top: 60px;
  }
}

@media (max-width: 480px) {
  body {
    font-size: 14px;
  }
}

/* Loading animation */
.loading {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.6s ease;
}

.loading.loaded {
  opacity: 1;
  transform: translateY(0);
}

/* Enhanced hover effects */
.hover-lift {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.hover-lift:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
}

/* Gradient background animation */
.gradient-bg {
  background: linear-gradient(-45deg, #2c5aa0, #4a7bc8, #6b9ce8, #2c5aa0);
  background-size: 400% 400%;
  animation: gradientShift 15s ease infinite;
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

/* Text gradient effect */
.gradient-text {
  background: linear-gradient(45deg, #2c5aa0, #4a7bc8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Button hover effect */
.btn-hover {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.btn-hover::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.5s;
}

.btn-hover:hover::before {
  left: 100%;
}

/* Card shadow effect */
.card-shadow {
  box-shadow: 0 5px 15px rgba(0,0,0,0.08);
  transition: all 0.3s ease;
}

.card-shadow:hover {
  box-shadow: 0 15px 35px rgba(0,0,0,0.12);
  transform: translateY(-3px);
}

/* Image hover effect */
.img-hover {
  transition: transform 0.3s ease;
}

.img-hover:hover {
  transform: scale(1.05);
}

/* Link hover effect */
.link-hover {
  position: relative;
  transition: color 0.3s ease;
}

.link-hover::after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: -2px;
  left: 0;
  background: currentColor;
  transition: width 0.3s ease;
}

.link-hover:hover::after {
  width: 100%;
}

/* Loading state */
.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #2c5aa0;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Responsive grid */
.responsive-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

/* Mobile optimization */
@media (max-width: 768px) {
  .responsive-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .container {
    padding: 0 1rem;
  }
}

/* Accessibility support */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* High contrast mode */
@media (prefers-contrast: high) {
  .card-shadow {
    border: 2px solid #333;
  }
  
  .btn-hover {
    border: 2px solid currentColor;
  }
}

/* Print styles */
@media print {
  .navbar,
  .footer,
  .cta-button {
    display: none !important;
  }
  
  body {
    background: white !important;
    color: black !important;
  }
}
</style>
